export const ENVIRONMENT = {
    BASE_URL : process.env.REACT_APP_BASE_URL
}